import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BreakdownEffect(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_4"
            options={props.breakdownEffectData}
            limitTags={5}
            value={props.breakdownEffectData.filter((item) => props.breakdownEffect?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.breakdownEffectLocalizationName ?? option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_3" {...params} margin="normal" label={t("BreakdownEffect")} variant="outlined" size="small" />}
            onChange={(event, newValue) => {
                props.HandleBreakdownEffect(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.breakdownEffectLocalizationName ?? option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
